import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateCustomerPrefs } from '../modules/update_customer_actions';

class CustomerPrefs extends Component {

  constructor(props) {
    super(props);
    // Perform truthy checks to catch null values; use 0 for 0 or null
    this.state = {
      newsletter: this.props.customer.email_preferences ? this.props.customer.email_preferences.newsletter : 0,
      sales:      this.props.customer.email_preferences ? this.props.customer.email_preferences.sales : 0,
      offers:     this.props.customer.email_preferences ? this.props.customer.email_preferences.offers : 0
    };
    this.handleChange       = this.handleChange.bind(this);
    this.updateCustomerPrefs = this.updateCustomerPrefs.bind(this);
  }

  handleChange( sType, event ) {
    let iNewValue = ( parseInt( this.state[ sType ], 10 ) === 1 ) ? 0 : 1;
    this.setState({ [ sType ]: iNewValue });
  }

  updateCustomerPrefs( evt ) {
    evt.preventDefault();
    this.props.dispatch( updateCustomerPrefs( this.state ) );
  }

  // This MUST be present on data that is set as local state components
  // so during logic/actions that change the state the props are updated to state.
  componentWillReceiveProps() {
    this.setState({
      newsletter: this.props.customer.email_preferences ? this.props.customer.email_preferences.newsletter : 0,
      sales:      this.props.customer.email_preferences ? this.props.customer.email_preferences.sales : 0,
      offers:     this.props.customer.email_preferences ? this.props.customer.email_preferences.offers : 0
    });
  }

  render() {
    return (
      <div className="section" id="shipping-info">
        <h4 className="alt">Email Preferences</h4>
        <div id="preferences-edit">
          <form name="customerPrefs" onSubmit={this.updateCustomerPrefs.bind( this )}>
            <label>
              <input
                type     = "checkbox"
                name     = "newsletter"
                checked  = {this.state.newsletter ? 'checked' : ''}
                onChange = {this.handleChange.bind( this, 'newsletter' )}
              />
               Newsletter
            </label>
            <label>
              <input
                type     = "checkbox"
                name     = "sales"
                checked  = {this.state.sales ? 'checked' : ''}
                onChange = {this.handleChange.bind( this, 'sales' )}
              />
              Club Sales and Specials
            </label>
            <label>
              <input
                type     = "checkbox"
                name     = "offers"
                checked  = {this.state.offers ? 'checked' : ''}
                onChange = {this.handleChange.bind( this, 'offers' )}
              />
              Special Offers
            </label>
            <button className="btn-tertiary">Update Preferences</button>
          </form>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'customer': state.customer };
}

export default connect(mapStateToProps)(CustomerPrefs);


// WEBPACK FOOTER //
// ./src/components/CustomerPrefs.jsx